const bodyElement: HTMLBodyElement = document.querySelector('body') as HTMLBodyElement;
let scrollPosition = 0;

export function disableBodyScroll(): void {
    scrollPosition = window.pageYOffset;
    bodyElement.style.top = `-${scrollPosition}px`;
    bodyElement.classList.add('disableScroll');
}

export function enableBodyScroll(): void {
    document.documentElement.style.scrollBehavior = 'auto';
    bodyElement.classList.remove('disableScroll');
    bodyElement.style.removeProperty('top');

    document.documentElement.style.removeProperty('scroll-behavior');

    window.scrollTo(0, scrollPosition);
}

export function preventBodyScroll(): void {
    bodyElement.classList.add('scroll-disabled');
}

export function allowBodyScroll(): void {
    bodyElement.classList.remove('scroll-disabled');
}
